import 'semantic-ui-dropdown/dropdown.min'
import 'semantic-ui-transition/transition.min'
import 'semantic-ui-css/components/icon.min.css'
import 'semantic-ui-css/components/transition.min.css'
import 'semantic-ui-css/components/dropdown.min.css'
import 'semantic-ui-css/components/label.min.css'
import {
  trans, DROPDOWN_ADD_RESULT, DROPDOWN_COUNT, DROPDOWN_MAX_SELECTIONS, DROPDOWN_NO_RESULTS, DROPDOWN_SERVER_ERROR
} from '../../translator'

if (DROPDOWN_ADD_RESULT &&
    DROPDOWN_COUNT &&
    DROPDOWN_MAX_SELECTIONS &&
    DROPDOWN_NO_RESULTS &&
    DROPDOWN_SERVER_ERROR) {
  // Only override the messages if all translations are available
  // When printing, we don't use dropdowns, so the translations are not available
  $.fn.dropdown.settings.message = {
    ...$.fn.dropdown.settings.message,
    addResult: trans(DROPDOWN_ADD_RESULT, {}, 'common'),
    count: trans(DROPDOWN_COUNT, {}, 'common'),
    maxSelections: trans(DROPDOWN_MAX_SELECTIONS, {}, 'common'),
    noResults: trans(DROPDOWN_NO_RESULTS, {}, 'common'),
    serverError: trans(DROPDOWN_SERVER_ERROR, {}, 'common')
  }
}

export default function () {
  $('.ui.dropdown.dropdownAutomatic').dropdown(
    {
      fullTextSearch: true,
      forceSelection: false
    }
  )

  $('.ui.dropdown.dropdownAutomatic-clearable').dropdown(
    {
      fullTextSearch: true,
      clearable: true,
      forceSelection: false
    }
  )
}
